import { render, staticRenderFns } from "./TableOperations.vue?vue&type=template&id=0cec69c9&"
import script from "./TableOperations.vue?vue&type=script&lang=js&"
export * from "./TableOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports